import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";
import Title_ru_RU       from "@/core/misc/decorators/Title_ru_RU";
import TYPES             from "@/core/services/Changelogs/types";
import BaseEntity 	     from "@/core/misc/BaseEntity";
import Address 	     	 from "@/domains/Address/Address";
import Partner 		     from "@/domains/Partners/Partner";
import TransportZone     from "@/domains/TransportZones/TransportZone";
import Core 		     from "@/core/Core";
import Coordinates       from "@/core/types/Coordinates";

@Title_ru_RU_Class('Склад')
class Store extends BaseEntity {

	static Events = {
		Created: 'store:created',
		Updated: 'store:updated',
		Deleted: 'store:deleted'
	} as const;

	@Title_ru_RU('Адрес склада', TYPES.OBJECT)
	public address: Address;

	@Title_ru_RU('Наименование', TYPES.STRING)
	public name: string;

	@Title_ru_RU('График работы склада и контактные лица', TYPES.STRING)
	public workingTime: string | null;

	@Title_ru_RU('Особые требования на складе', TYPES.STRING)
	public notes: string | null;

	@Title_ru_RU('Транспортная зона', TYPES.OBJECT)
	public transportZone: TransportZone | null;

	public partner: Partner;

	/** Статус "черновик". Пользователи без админских прав могут создавать только черновики */
	@Title_ru_RU('"черновик"', TYPES.BOOLEAN_MARK)
	public isDraft: boolean;

	@Title_ru_RU('Ссылка на карту с местоположением склада', TYPES.STRING)
	public mapLink: string | null = null;

	@Title_ru_RU('Координаты склада', TYPES.COORDINATES)
	public coordinates: Coordinates = new Coordinates(null, null);

	constructor() {
		super();
		this.address = new Address();
		this.isDraft = Core.currentUser?.isAdmin ? false : true;
	}

	toString(): string {
		return `${this?.name ?? this?.address?.stringRepresentation ?? ''}`;
	};

	/**
	 * Склад из свободного ввода VSuggestionSelectV2.
	 *
	 * Базовая реализация не годится: она заполняет name, а в контрол у склада
	 * вводят адрес. Введённое кладём прямо в адрес.
	 *
	 * Партнёра не проставляем: у контрола на входе только строка, а бэк при
	 * неявном создании и так получает владельца отдельным аргументом
	 * (StoresService::add($store, $partnerId)).
	 */
	static fromSuggestion(name: string): Store {
		const store = new this();

		store.address.stringRepresentation = name;

		return store;
	}

	static fromPartner(partner: Partner): Store {
		const store = new this();

		store.partner = partner;

		return store;
	}

	static fromServer(data: any, store = new Store()): Store {
		super.fromServer(data, store);

    store.address = Core.utils.hydrate(data.address, Address.fromServer)!;

		store.transportZone = Core.utils.hydrate(data.transportZone, TransportZone.fromServer);

    store.partner = Core.utils.hydrate(data.partner, Partner.fromServer)!;

		store.mapLink = data.mapLink;

		store.coordinates = new Coordinates(data?.coordinates?.longitude, data?.coordinates?.latitude);

		return store;
	}

	getReasonCannotSetAsDraft() {
		if (this.isDraft === true) return 'Уже черновик';
		if (Core.currentPartner?.isSeller) return 'У вас нет прав';

		return null;
	}

	getReasonCannotApprove() {
		if (this.isDraft === false) return 'Склад подтверждён';
		if (Core.currentUser?.isAdmin === false) return 'У вас нет прав';

		return null;
	}

  /** Задана ли складу транспортная зона. Без неё маршрут не построить. */
  validateTransportZone(): string | null {
    if (Core.utils.isNullOrUndefined(this.transportZone)) {
      return `Складу «${this.address}» не задана транспортная зона — обратитесь к администратору`;
    }
    else {
      return null;
    }
  }
}

export default Store;
